import { z } from "zod";
export const TableShapeSchema = z.enum(["round", "rectangular", "square", "oval"]);
export const TableSchema = z.object({
    id: z.string(),
    name: z.string(),
    shape: TableShapeSchema,
    capacity: z.number().int().min(2).max(30),
    positionX: z.number(),
    positionY: z.number(),
    rotation: z.number().default(0),
    guestIds: z.array(z.string()).default([]),
    /**
     * Per-seat occupant mapping. Index = seat number, value = occupant key or
     * null (empty). Occupant keys: `"guestId"` for host, `"guestId/+1"` for
     * plus-one, `"guestId/c/childId"` for a child. Empty array means
     * "auto-layout from guestIds order" (backward compat).
     */
    seatMap: z.array(z.string().nullable()).default([]),
    /**
     * Zero-based seat indices that are deactivated for this table (e.g. seats
     * against a wall). Hidden seats are excluded from guest assignment and
     * rendered as greyed-out pips. Defaults to [] (all seats active).
     */
    hiddenSeats: z.array(z.number().int().nonnegative()).default([]),
    color: z.string().nullable().optional(),
    isVip: z.boolean().default(false),
    notes: z.string().nullable().optional(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const RoomElementSchema = z.object({
    id: z.string(),
    type: z.enum([
        "stage",
        "danceFloor",
        "bar",
        "entrance",
        "photoBooth",
        "piano",
        "grandPiano",
        "fountain",
        "decoration",
        "buffet",
        "djBooth",
        "sweetTable",
        "guestBook",
        "outdoorSpace",
    ]),
    positionX: z.number(),
    positionY: z.number(),
    width: z.number(),
    height: z.number(),
    rotation: z.number().default(0),
    label: z.string().nullable().optional(),
});
